import { render, staticRenderFns } from "./salarydealpjx.vue?vue&type=template&id=658e68a6"
import script from "./salarydealpjx.vue?vue&type=script&lang=js"
export * from "./salarydealpjx.vue?vue&type=script&lang=js"
import style0 from "./salarydealpjx.vue?vue&type=style&index=0&id=658e68a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports